(function () {
	const roots = document.querySelectorAll('[data-collapsible-tabs]')

	if (!roots.length) {
		return
	}

	const activateTab = (root, tabs, panels, slot) => {
		tabs.forEach((tab) => {
			const isActive = tab.dataset.slot === slot
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false')
			tab.setAttribute('tabindex', isActive ? '0' : '-1')
		})

		panels.forEach((panel) => {
			const isActive = panel.dataset.slot === slot
			panel.classList.toggle('is-active', isActive)
		})

		root.dataset.activeSlot = slot
	}

	roots.forEach((root) => {
		const tabs = Array.from(root.querySelectorAll('[role="tab"]'))
		const panels = Array.from(root.querySelectorAll('[role="tabpanel"]'))

		if (!tabs.length || !panels.length) {
			return
		}

		const defaultSlot = root.dataset.defaultSlot
		const hasDefault = tabs.some((tab) => tab.dataset.slot === defaultSlot)
		const initialSlot = hasDefault && defaultSlot !== 'first'
			? defaultSlot
			: tabs[0].dataset.slot

		root.classList.add('is-enhanced')
		activateTab(root, tabs, panels, initialSlot)

		tabs.forEach((tab) => {
			tab.addEventListener('click', () => {
				activateTab(root, tabs, panels, tab.dataset.slot)
			})

			tab.addEventListener('keydown', (event) => {
				const currentIndex = tabs.indexOf(tab)
				let nextIndex = currentIndex

				if (event.key === 'ArrowRight') {
					nextIndex = (currentIndex + 1) % tabs.length
				} else if (event.key === 'ArrowLeft') {
					nextIndex = (currentIndex - 1 + tabs.length) % tabs.length
				} else if (event.key === 'Home') {
					nextIndex = 0
				} else if (event.key === 'End') {
					nextIndex = tabs.length - 1
				} else {
					return
				}

				event.preventDefault()
				const nextTab = tabs[nextIndex]
				activateTab(root, tabs, panels, nextTab.dataset.slot)
				nextTab.focus()
			})
		})
	})
})()
